
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";

const CalendarIntegrationHeader = () => {
  return (
    <div className="container mx-auto max-w-4xl py-6 sm:py-12 px-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6 sm:mb-8">
        <Link to="/">
          <Button variant="outline" className="bg-background border-border hover:bg-muted">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>
        <h1 className="text-2xl sm:text-3xl font-semibold text-foreground text-center sm:text-left w-full sm:w-auto">
          Calendar Integration
        </h1>
      </div>
      
      <div className="bg-card border border-border p-4 sm:p-8 rounded-2xl shadow-xl">
        <div className="flex items-center justify-center mb-6 sm:mb-8">
          <Calendar className="h-16 w-16 sm:h-24 sm:w-24 text-primary" />
        </div>
        
        <h2 className="text-lg sm:text-xl font-medium text-center mb-3 sm:mb-4 text-foreground px-2">
          Connect Your Calendar
        </h2>
        <p className="text-center text-muted-foreground mb-6 sm:mb-8 text-sm sm:text-base px-2 leading-relaxed">
          Connect your Google Calendar or Outlook Calendar to receive reminders and schedule events.
        </p>
      </div>
    </div>
  );
};

export default CalendarIntegrationHeader;
